// extracted by mini-css-extract-plugin
export default {"anchorWrapper":"Anchor_anchorWrapper__2TWyY","anchorBlock":"Anchor_anchorBlock__2jBeX"};